<template>
    <h1>
        Logging Out......
    </h1>
</template>

<script>
import axios from 'axios'

export default {
        name: 'Logout',
        created: function () {

            this.handleLogout()
        },
        methods: {
            handleLogout: function () {
                console.log('std logout')
                axios.delete('/auth/session').then( () => {
                    console.log('Asking to Logout')
                  this.deleteSession()
                }, error => {
                  this.deleteSession()
                    console.log('Error in updating logout session', error)
                })
            },
          deleteSession() {
            this.$store.commit('loggedOut')
            this.$router.push('/login')
            window.location.reload()
          }
        }
    }
</script>

<style scoped>

</style>
